import Immutable from 'seamless-immutable'
import * as actions from './actions'

const initialState = Immutable.from({
  error: false,
  isFetching: false,
  parameters: {
    r: null,
    m: null,
    sa: null,
  },
  havePermission: null,
})

const geolocation = (state = initialState, { type, payload, error }) => {
  switch (type) {
    case actions.REQUEST_GEOLOCATION:
      return state.merge({
        error: false,
        isFetching: true,
      })
    case actions.RECEIVE_GEOLOCATION:
      if (error) {
        return state.merge({
          error,
          isFetching: false,
        })
      }

      return state.merge({
        error: false,
        isFetching: false,
        parameters: payload,
      })
    case actions.SET_PERMISSION:
      return state.set('havePermission', payload)
    default:
      return state
  }
}

export default geolocation
